import React, { useEffect, useState } from 'react';
import { OperatorsVService } from '../../../services/V2/padre';
import { dateToLocal, formatMoney, handleError, handleErrorToast } from '../../shared/Functions';
import { ChargebacksService } from '../../../services/ChargebacksService';
import { CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Link } from '@material-ui/core';
import { CustomTable } from '../../shared/CustomTable';
import '../../../scss/UVP.scss';
import Papa from 'papaparse';

export const UVPReturns = ({errorToast, successToast, setSelectedBatch, operatorId}) => {
    const tableRef: any = React.createRef();

    const [operator, setOperator] = useState<any>();
    const [refresh, setRefresh] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [showFileLoad, setShowFileLoad] = useState<boolean>(false);
    const [csvArray, setCsvArray] = useState<any[]>([]);

    useEffect(() => {
        if(!operatorId) return;
        tableRef?.current?.onQueryChange();
        OperatorsVService.operatorsVGetById(operatorId ?? "")
            .then(x => setOperator(x))
            .catch(x => handleError(x))
    }, [operatorId]) // eslint-disable-line react-hooks/exhaustive-deps

    const returnsUpload = (data) => {
        let newReturns: any[] = [];

        for(let i = 0; i < data.length; i++){
            let transRefId = data[i]["TransRefID"]
            let fuzeId = data[i]["Fuze ID"]
            let utilityAccountNumber = data[i]["Utility Account Number"] && data[i]["Utility Account Number"] !== "" ? data[i]["Utility Account Number"] : null
            let utilityAccountNo = data[i]["Utility Account No"] && data[i]["Utility Account No"] !== "" ? data[i]["Utility Account No"] : null
            let disputeCaseAmount = data[i]["Dispute Case Amount"] && data[i]["Dispute Case Amount"] !== "" ? parseFloat(data[i]["Dispute Case Amount"]) : null
            let disputeCaseDate = data[i]["Dispute Case Date"] && data[i]["Dispute Case Date"] !== "" ? new Date(data[i]["Dispute Case Date"]).toISOString() : null
            let disputeReasonCode = data[i]["Dispute Reason Code"] && data[i]["Dispute Reason Code"] !== "" ? data[i]["Dispute Reason Code"] : null
            let disputeReasonDescription = data[i]["Dispute Reason Description"] && data[i]["Dispute Reason Description"] !== "" ? data[i]["Dispute Reason Description"] : null
            let achReturnAmount = data[i]["ACH Return Amount"] && data[i]["ACH Return Amount"] !== "" ? parseFloat(data[i]["ACH Return Amount"]) : null
            let achStatusDate  = data[i]["ACH Status Date"] ? new Date(data[i]["ACH Status Date"]).toISOString() : null
            let rejectReason = data[i]["Reject Reason"] && data[i]["Reject Reason"] !== "" ? data[i]["Reject Reason"] : null
            let disputeReason = data[i]["Dispute Reason"] && data[i]["Dispute Reason"] !== "" ? data[i]["Dispute Reason"] : null

            let newReturn = {
                transRefId: transRefId,
                fuzeId: fuzeId,
                utilityAccountNumber: utilityAccountNumber,
                utilityAccountNo: utilityAccountNo,
                disputeCaseAmount: disputeCaseAmount,
                disputeCaseDate: disputeCaseDate,
                disputeReasonCode: disputeReasonCode,
                disputeReasonDescription: disputeReasonDescription,
                achReturnAmount: achReturnAmount,
                achStatusDate: achStatusDate,
                rejectReason: rejectReason,
                disputeReason: disputeReason
            };
            newReturns.push(newReturn)
        }

        setLoading(true)
        ChargebacksService.chargebacksVCreateBatch(newReturns, operator.id)
            .then(x => {
                successToast(`Batch Created.`)
                setSelectedBatch(x)
                setLoading(false)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
                setShowFileLoad(false)
            })
    }

    const handleOnChange = (e) => {
        Papa.parse(e.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                let data: any[] = results.data ?? []
                setCsvArray(data)
            },
            error: function (error) {
                errorToast(`There was an error processing your file: ${error}. Please try again.`)
                setShowFileLoad(false)
            }
        });
    };

    if(!operator) return null;

    return (
        <React.Fragment>
            <Dialog onClose={() => { }} open={showFileLoad} fullWidth>
                <DialogContent style={{ padding: "8px 0px", textAlign: "left" }}>
                    <h5 style={{ marginLeft: "10px", fontWeight: "bold" }}>File Upload</h5>
                    <Divider />
                    <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                        <b className='uvp-label' style={{ textAlign: "left" }}>Select a file to upload :</b>
                        <br />
                        <input
                            className='uvp-label'
                            type="file"
                            id="returnsFile"
                            name="returnsFile"
                            accept="text/csv"
                            onChange={handleOnChange} />
                    </div>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center" }}>
                    <button className="green-button uvp-button" disabled={csvArray.length < 1} onClick={() => returnsUpload(csvArray)}>Upload</button>
                    <button className="gray-button uvp-button" onClick={() => { setShowFileLoad(false); setCsvArray([]) }} style={{marginRight:"10px"}}>Cancel</button>
                </DialogActions>
            </Dialog>
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button className='uvp-button gray-button' onClick={() => setRefresh(true)}>Refresh</button>
                    <button className='uvp-button green-button' onClick={() => setShowFileLoad(true)}>Upload</button>
                </div>
                <div style={{backgroundColor: "white", borderRadius: "10px", marginTop: "20px"}}>
                    <CustomTable
                        refresh={refresh}
                        columns={[
                            { title: 'Batch ID', field: 'batchId', render: rowData => <Link className="clickable" onClick={() => setSelectedBatch(rowData)}>{rowData.batchId}</Link> },
                            { title: 'Batch Status', field: '', render: rowData => rowData?.status },
                            { title: 'Run Date', field: 'runDate', render: rowData => rowData.runDate ? dateToLocal(rowData.runDate).toLocaleString() : null },
                            { title: 'Total Count', field: 'count' },
                            { title: 'Type', field: 'batchType' },
                            { title: 'Total Value', field: 'totalAmount', render: rowData => formatMoney(rowData.totalAmount) },
                        ]}
                        dataEndpoint={(query) => {
                            return new Promise((resolve, reject) => {
                                ChargebacksService.chargebacksVGetAll({
                                    filters: [
                                        {
                                            property: "OperatorId",
                                            value: operatorId
                                        }
                                    ],
                                    pageNumber: query.pageNumber,
                                    numberPerPage: 15,
                                    orderBy: "BatchId",
                                    orderByDesc: true
                                })
                                .then((x:any) => {
                                    resolve({
                                        items: x.items,
                                        numberOfItems: x.numberOfItems
                                    })
                                })
                                .catch(x => reject(x))
                            })
                        }}
                        dataSet={null}
                        pageSize={15}
                        enablePaging={false}
                        actions={[]}
                        setRefresh={setRefresh}
                        title={''}
                        districtId={null}
                        addedQuery={null}
                        hiddenColumns={[]}
                        setHiddenColumns={null}
                        hiddenColumnsDisabled={true}
                        tableHeight={"407px"}
                        enableSearch={false}
                        searchPlaceholder={null} />
                </div>
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
            </Grid>
        </React.Fragment>
    );
}
